import { useEffect } from "react";

/**
 * Injects schema.org JSON-LD for a single product page.
 *
 * Merchant Center discovers products by crawling structured data, so this is only
 * ever rendered when the backend says the product is in our Google feed. Brochure,
 * catalogue and enquiry-only pages get nothing - that is what stopped Google
 * helping itself to 240 products off the old WooCommerce site.
 */
export default function ProductSchema({ data }) {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.dataset.productSchema = "true";
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => el.remove();
  }, [data]);

  return null;
}
